<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="客户信息：">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
                <el-option :label="item.name" :value="item.level" v-for="item in identityList" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div>
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="客户信息" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.name }}</span>
                <span style="display: block;">{{ row.pho }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="用友编码" prop="" align="center"></el-table-column>
          <el-table-column label="订单数" prop="orderCount" align="center"></el-table-column>
          <el-table-column label="余额/现金支付总价" prop="rmbyueMoney" sortable="custom" align="center">
            <template slot-scope="{row}">
              {{row.balancePayAmount}}/{{ row.cashPayAmount }}
            </template>
          </el-table-column>
          <el-table-column label="零售价支付总价" prop="xiaoduCoinPayAmount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="赠送总支付总价" prop="tuitionPayAmount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="学习时长(分钟)" prop="courseLearningDuration" sortable="custom" align="center"></el-table-column>
          <el-table-column label="课程数" prop="courseOrderCount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="总业绩" prop="performance" sortable="custom" align="center" width="100"></el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
import Times from '../../components/times.vue'
import Navs from '../../components/navs.vue'
import customerLevelApi from '@/api/sys/customerLevel'
import clientListApi from '@/api/client/clientList'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        performanceSortSign: -1
      },
      selectItems: [],
      times: null,
      navList: [
        { name: '团队客户', id: 1 },
        { name: '直属客户', id: 2 }
      ],
      navIndex: 0,
      identityList: [],
      today: '',
      id: null,
      isServiceTeacher: 0
    }
  },
  created() {
    let queryObj = this.$route.query;
    if (queryObj.index) this.navIndex = queryObj.index;
    if (queryObj.id) this.id = +queryObj.id;
    if (queryObj.isServiceTeacher) this.isServiceTeacher = +queryObj.isServiceTeacher;
    this.navList = this.isServiceTeacher ? [{ name: '团队大客户', id: 1 },{ name: '直属大客户', id: 2 }] : this.navList;
  },
  mounted() {
    this.$refs.navs.navIndex = this.navIndex * 1;
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    this.doQueryList({ pageNo: 1 })
    this.getBusinessStanding()
  },
  methods: {
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'orderCount': 'orderCountSortSign',
        'rmbyueMoney': 'balancePayAmountSortSign',
        'xiaoduCoinPayAmount': 'xiaoduCoinPayAmountSortSign',
        'tuitionPayAmount': 'tuitionPayAmountSortSign',
        'courseLearningDuration': 'courseLearningDurationSortSign',
        'courseOrderCount': 'courseOrderCountSortSign',
        'performance': 'performanceSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 3
      }).then(({
        data
      }) => {
        this.identityList = data
        console.log('客户身份: ', data);
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        pageNo: 1,
        pageSize: 10,
        performanceSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      this.navIndex = index;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/technology/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query, }
      
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      this.listLoading = true
      const Ins = this.isServiceTeacher ? clientListApi.listForStatistics : clientListApi.getKeHuStatistics
      const navId = (this.navList[this.navIndex] || {}).id
      if (this.isServiceTeacher) {
        Object.assign(query, navId === 1
          ? { technicianParentIdForBig: this.id }
          : { technicianIdForBig: this.id }
        )
      } else {
        query.viewType = navId
        query.techId = this.id 
      }
      return Ins(query).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path, row, type) {
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}`)
      } else {
        this.$router.push(`${path}?id=${row.id}`)
      }
      window.location.reload();
    }
  }
}
</script>
<style scoped lang="scss">
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
